import type { SVGProps } from "react";
export function Undo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m.800049.800049h14.4v14.4h-14.4z" />
      </clipPath>
      <g
        clipPath="url(#a)"
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="m1.25005.798464c.24853 0 .45.201472.45.449996v4.05h4.05c.24853 0 .45.20148.45.45 0 .24853-.20147.45-.45.45h-4.5c-.24853 0-.450001-.20147-.450001-.45v-4.5c0-.248524.201471-.449996.450001-.449996z" />
        <path d="m7.01588.866593c1.30768-.18118 2.64.000661 3.85132.525647 1.2113.52498 2.2549 1.37289 3.0168 2.45103s1.2127 2.34499 1.3031 3.66207c.0904 1.31707-.183 2.63366-.7904 3.80576-.6074 1.1722-1.5254 2.1547-2.6536 2.8403s-2.42315 1.0478-3.74332 1.0471c-.24852-.0002-.44988-.2018-.44973-.4503.00014-.2485.20173-.4499.45026-.4497 1.15515.0006 2.28829-.3163 3.27539-.9162.9872-.5999 1.7904-1.4596 2.3219-2.4853.5315-1.02558.7707-2.17759.6916-3.33002-.0791-1.15244-.4735-2.26094-1.1402-3.20431-.6666-.94337-1.5798-1.6853-2.6397-2.14466-1.0599-.45935-2.22569-.61847-3.3699-.45993-1.14422.15853-2.22283.6286-3.1179 1.35882s-1.57214 1.69248-1.95719 2.78156c-.08284.23432-.33995.35711-.57426.27427-.23432-.08284-.35711-.33995-.27427-.57427.44006-1.24466 1.21386-2.34438 2.23679-3.17892 1.02294-.83454 2.25563-1.37177 3.56331-1.552947z" />
      </g>
    </svg>
  );
}
